import React, { useMemo } from "react";
import { isStartListStatus, isLiveStatus } from "helpers/status";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import Status from "components/presentation/Status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import PhotoFinish from "components/general/PhotoFinish";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


//INDIVIDUALS
import { TableColumns as ColumnsIndividualStart, TableColumnsSM as ColumnsIndividualStartSM, TableColumnsParasEventsPTVPTW as ColumnsIndividualPTVPTWStart, TableColumnsSMParasEventsPTVPTW as ColumnsIndividualSMPTVPTWStart } from 'components/sports/tri/events/individual/start/Columns'
import {
    TableColumnsLive as ColumnsIndividual,
    TableColumnsLiveParasEventsPTVPTW as ColumnsIndividualPTVPTW,
    TableColumnsLiveSM as ColumnsIndividualSM,
    TableColumnsFinish as ColumnsIndividualRes,
    TableColumnsFinishParasEventsPTVPTW as ColumnsIndividualResPTVPTW,
    TableColumnsFinishSM as ColumnsIndividualResSM
} from 'components/sports/tri/events/individual/results/Columns'


import { TableExpanded as TBEIndividual } from 'components/sports/tri/events/individual/results/TableExpanded'


//MIXED RELAY
import { TableColumns as ColumnsMixedStart, TableColumnsSM as ColumnsMixedStartSM } from 'components/sports/tri/events/mixed/start/Columns'
import {
    TableColumnsLive as ColumnsMixed,
    TableColumnsLiveSM as ColumnsMixedSM,
    TableColumnsFinish as ColumnsMixedRes,
    TableColumnsFinishSM as ColumnsMixedResSM
} from 'components/sports/tri/events/mixed/results/Columns'
import { TableExpanded as TBEMixed } from 'components/sports/tri/events/mixed/results/TableExpanded'


import { filterArray, isParalympic } from "helpers/utils";

//import TableMin from "components/table/TableMin";
import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils'
//Race Info
import TriRaceInfo from 'components/sports/tri/views/TriRaceInfo'
//TRI Helpers
import { getIsIndividual, getIsPTVPTW } from 'components/sports/tri/helper/TriHelpers'


const getConfiguration = (data, rsc, resultStatus, breakPoint, caption, mirs_competition) => {

    const columnsAdded = data.progressBar
    const isStartList = isStartListStatus(resultStatus) ? true : false
    const isLive = isLiveStatus(resultStatus) ? true : false
    let isIndividual = getIsIndividual(rsc);
    let isPTVPTW = getIsPTVPTW(rsc);


    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            isStartList: isStartList,
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };


    configuration.caption = <CaptionTable
        leftCol={<>{caption}</>}
        rightCol={<Status typeToPrint='result' scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={resultStatus} />}
    />


    configuration.sortBy = isStartList
        ? [{ id: 'Bib', desc: false }]
        : isLive
            //is live
            ? [{ id: 'Rank', desc: false }]
            //Finish
            : [{ id: 'Rank', desc: false }]


    configuration.filters = {
        ei_type: ['DISPLAY'],
        ei_code: ['INTERMEDIATE_CURRENT']
    };

    if (isIndividual) {
        configuration.columns = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? isPTVPTW ? ColumnsIndividualSMPTVPTWStart() : ColumnsIndividualStartSM()
                : isPTVPTW ? ColumnsIndividualPTVPTWStart() : ColumnsIndividualStart()
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsIndividualSM(columnsAdded)
                    : isPTVPTW ? ColumnsIndividualPTVPTW(columnsAdded) : ColumnsIndividual(columnsAdded)
                : breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsIndividualResSM(columnsAdded)
                    : isPTVPTW ? ColumnsIndividualResPTVPTW(columnsAdded) : ColumnsIndividualRes(columnsAdded);
    } else {
        //Mixed
        configuration.columns = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsMixedStartSM()
                : ColumnsMixedStart()
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsMixedSM(columnsAdded)
                    : ColumnsMixed(columnsAdded)
                : breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsMixedResSM(columnsAdded)
                    : ColumnsMixedRes(columnsAdded);

    }


    return configuration;
};


const TriResults = ({ data, caption }) => {
    const { mirs_competition, mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;

    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas
    //aunque no hay cambios
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus, breakPoint, caption, mirs_competition), [resultStatus, mirs_rsc, breakPoint]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => {

        let componentExpanded = '';
        if (getIsIndividual(mirs_rsc)) {
            componentExpanded = <TBEIndividual row={row?.original} config={configEvent.configs.columnsAdded} />
        } else {
            componentExpanded = <TBEMixed row={row?.original} config={configEvent.configs.columnsAdded} />
        }
        return (
            <LoaderSubComponent component={componentExpanded} />
        )
        // eslint-disable-next-line
    }, [resultStatus]);

    const items = data?.results?.items

    // const showAll = showAllExtendedResults || showAllTeamAthletes;
    const hasConfiguration = configEvent.configs.columnsAdded;

    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []
    if (!hasConfiguration) hiddenColumns.push('Expander')


    return (
        <>

            {data?.results ? (
                <>
                    {!isStartListStatus(resultStatus) ? <PhotoFinish data={data?.images} /> : ''}
                    {data?.results?.items ? (
                        < MirsTable
                            className='table-result'
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar
                            columns={configEvent.columns}
                            //subcomponente a renderizar, extended
                            renderRowSubComponent={renderRowSubComponent}
                            //pageSizeCustom={data.items.length} //ponerlo por defecto en el componente
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde
                            hiddenColumns={hiddenColumns}
                            //When show tble is sorted by
                            initialSortBy={configEvent.sortBy}
                            //Show buttons move to splits
                            //showNavExtendedData={true}
                            hasRelatedTimeline={true}
                            id={`mirs-table-results-${mirs_rsc}`}
                        />
                    ) : ('')
                    }

                </>
            ) : (
                <span><em>No data available</em></span>
            )
            }
            {data?.config ? (
                <TriRaceInfo config={data.config} />
            ) : ""}
        </>
    );
};

export default TriResults;
